"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "lookupOrLtarBuilder", {
    enumerable: true,
    get: function() {
        return lookupOrLtarBuilder;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _conditionV2 = require("~/db/conditionV2");
const _formulaquerybuilderhelpers = require("~/db/formulav2/formula-query-builder.helpers");
const _genRollupSelectv2 = /*#__PURE__*/ _interop_require_default(require("~/db/genRollupSelectv2"));
const _helpers = require("~/helpers");
const _models = require("~/models");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const lookupOrLtarBuilder = (params)=>async ({ tableAlias, parentColumns })=>{
        const { baseModelSqlv2, column, knex = baseModelSqlv2.dbDriver, context = baseModelSqlv2.context, tableAlias: _tableAlias, //model = baseModelSqlv2.model,
        _formulaQueryBuilder, getAliasCount } = params;
        let selectQb;
        let isArray = false;
        const alias = `__nc_formula${getAliasCount()}`;
        const lookup = column.uidt === _nocodbsdk.UITypes.Lookup ? await column.getColOptions(context) : null;
        {
            const relationCol = lookup ? await lookup.getRelationColumn(context) : column;
            const relation = await relationCol.getColOptions(context);
            // if (relation.type !== RelationTypes.BELONGS_TO) continue;
            const { parentContext, childContext, mmContext, refContext } = await relation.getParentChildContext(context);
            const childColumn = await relation.getChildColumn(childContext);
            const parentColumn = await relation.getParentColumn(parentContext);
            const childModel = await childColumn.getModel(childContext);
            await childModel.getColumns(childContext);
            const parentModel = await parentColumn.getModel(parentContext);
            await parentModel.getColumns(parentContext);
            let relationType = (0, _nocodbsdk.isMMOrMMLike)(relationCol) ? _nocodbsdk.RelationTypes.MANY_TO_MANY : relation.type;
            if (relationType === _nocodbsdk.RelationTypes.ONE_TO_ONE) {
                var _relationCol_meta;
                relationType = ((_relationCol_meta = relationCol.meta) == null ? void 0 : _relationCol_meta.bt) ? _nocodbsdk.RelationTypes.BELONGS_TO : _nocodbsdk.RelationTypes.HAS_MANY;
            }
            let lookupColumn = lookup ? await lookup.getLookupColumn(refContext) : null;
            switch(relationType){
                case _nocodbsdk.RelationTypes.BELONGS_TO:
                    {
                        const parentBaseModel = await _models.Model.getBaseModelSQL(parentContext, {
                            model: parentModel,
                            dbDriver: baseModelSqlv2.dbDriver
                        });
                        selectQb = knex(knex.raw(`?? as ??`, [
                            parentBaseModel.getTnPath(parentModel.table_name),
                            alias
                        ])).where(`${alias}.${parentColumn.column_name}`, knex.raw(`??`, [
                            `${tableAlias != null ? tableAlias : baseModelSqlv2.getTnPath(childModel.table_name)}.${childColumn.column_name}`
                        ]));
                        lookupColumn = lookupColumn != null ? lookupColumn : parentModel.displayValue;
                        await (0, _conditionV2.extractLinkRelFiltersAndApply)({
                            context,
                            column,
                            table: parentModel,
                            baseModel: parentBaseModel,
                            qb: selectQb,
                            alias
                        });
                    }
                    break;
                case _nocodbsdk.RelationTypes.HAS_MANY:
                    {
                        const childBaseModel = await _models.Model.getBaseModelSQL(childContext, {
                            model: childModel,
                            dbDriver: baseModelSqlv2.dbDriver
                        });
                        isArray = relation.type !== _nocodbsdk.RelationTypes.ONE_TO_ONE;
                        selectQb = knex(knex.raw(`?? as ??`, [
                            childBaseModel.getTnPath(childModel.table_name),
                            alias
                        ])).where(`${alias}.${childColumn.column_name}`, knex.raw(`??`, [
                            `${tableAlias != null ? tableAlias : baseModelSqlv2.getTnPath(parentModel.table_name)}.${parentColumn.column_name}`
                        ]));
                        lookupColumn = lookupColumn != null ? lookupColumn : childModel.displayValue;
                        await (0, _conditionV2.extractLinkRelFiltersAndApply)({
                            context,
                            column,
                            table: childModel,
                            baseModel: childBaseModel,
                            qb: selectQb,
                            alias
                        });
                    }
                    break;
                case _nocodbsdk.RelationTypes.MANY_TO_MANY:
                    {
                        const parentBaseModel = await _models.Model.getBaseModelSQL(parentContext, {
                            model: parentModel,
                            dbDriver: baseModelSqlv2.dbDriver
                        });
                        isArray = true;
                        const mmModel = await relation.getMMModel(context);
                        const mmParentColumn = await relation.getMMParentColumn(context);
                        const mmChildColumn = await relation.getMMChildColumn(context);
                        const mmBaseModel = await _models.Model.getBaseModelSQL(mmContext, {
                            model: mmModel,
                            dbDriver: baseModelSqlv2.dbDriver
                        });
                        const assocAlias = `__nc${getAliasCount()}`;
                        selectQb = knex(knex.raw(`?? as ??`, [
                            parentBaseModel.getTnPath(parentModel.table_name),
                            alias
                        ])).join(knex.raw(`?? as ??`, [
                            mmBaseModel.getTnPath(mmModel.table_name),
                            assocAlias
                        ]), `${assocAlias}.${mmParentColumn.column_name}`, `${alias}.${parentColumn.column_name}`).where(`${assocAlias}.${mmChildColumn.column_name}`, knex.raw(`??`, [
                            `${tableAlias != null ? tableAlias : baseModelSqlv2.getTnPath(childModel.table_name)}.${childColumn.column_name}`
                        ]));
                        lookupColumn = lookupColumn != null ? lookupColumn : parentModel.displayValue;
                        await (0, _conditionV2.extractLinkRelFiltersAndApply)({
                            context,
                            column,
                            table: parentModel,
                            baseModel: parentBaseModel,
                            qb: selectQb,
                            alias
                        });
                    }
                    break;
            }
            let prevAlias = alias;
            // set initial lookup context
            let lookupContext = refContext;
            while(lookupColumn.uidt === _nocodbsdk.UITypes.Lookup){
                // overwrite lookupContext from previous iteration
                const context = lookupContext;
                const nestedAlias = `__nc_formula${getAliasCount()}`;
                const nestedLookup = await lookupColumn.getColOptions(context);
                const relationCol = await nestedLookup.getRelationColumn(context);
                const relation = await relationCol.getColOptions(context);
                // if any of the relation in nested lookup is
                // not belongs to then ignore the sort option
                // if (relation.type !== RelationTypes.BELONGS_TO) continue;
                const { parentContext, childContext, refContext, mmContext } = await relation.getParentChildContext(context);
                // reset for next iteration
                lookupContext = refContext;
                const childColumn = await relation.getChildColumn(childContext);
                const parentColumn = await relation.getParentColumn(parentContext);
                const childModel = await childColumn.getModel(childContext);
                await childModel.getColumns(childContext);
                const parentModel = await parentColumn.getModel(parentContext);
                await parentModel.getColumns(parentContext);
                const parentBaseModel = await _models.Model.getBaseModelSQL(parentContext, {
                    model: parentModel,
                    dbDriver: baseModelSqlv2.dbDriver
                });
                const childBaseModel = await _models.Model.getBaseModelSQL(childContext, {
                    model: childModel,
                    dbDriver: baseModelSqlv2.dbDriver
                });
                let relationType = relation.type;
                if (relationType === _nocodbsdk.RelationTypes.ONE_TO_ONE) {
                    var _relationCol_meta1;
                    relationType = ((_relationCol_meta1 = relationCol.meta) == null ? void 0 : _relationCol_meta1.bt) ? _nocodbsdk.RelationTypes.BELONGS_TO : _nocodbsdk.RelationTypes.HAS_MANY;
                }
                switch(relationType){
                    case _nocodbsdk.RelationTypes.BELONGS_TO:
                        {
                            selectQb.join(knex.raw(`?? as ??`, [
                                parentBaseModel.getTnPath(parentModel.table_name),
                                nestedAlias
                            ]), `${prevAlias}.${childColumn.column_name}`, `${nestedAlias}.${parentColumn.column_name}`);
                            await (0, _conditionV2.extractLinkRelFiltersAndApply)({
                                context,
                                column: lookupColumn,
                                table: parentModel,
                                baseModel: parentBaseModel,
                                qb: selectQb,
                                alias
                            });
                        }
                        break;
                    case _nocodbsdk.RelationTypes.HAS_MANY:
                        {
                            isArray = relation.type !== _nocodbsdk.RelationTypes.ONE_TO_ONE;
                            selectQb.join(knex.raw(`?? as ??`, [
                                childBaseModel.getTnPath(childModel.table_name),
                                nestedAlias
                            ]), `${prevAlias}.${parentColumn.column_name}`, `${nestedAlias}.${childColumn.column_name}`);
                            await (0, _conditionV2.extractLinkRelFiltersAndApply)({
                                context,
                                column: lookupColumn,
                                table: childModel,
                                baseModel: childBaseModel,
                                qb: selectQb,
                                alias
                            });
                        }
                        break;
                    case _nocodbsdk.RelationTypes.MANY_TO_MANY:
                        {
                            isArray = true;
                            const mmModel = await relation.getMMModel(mmContext);
                            const mmParentColumn = await relation.getMMParentColumn(mmContext);
                            const mmChildColumn = await relation.getMMChildColumn(mmContext);
                            const mmBaseModel = await _models.Model.getBaseModelSQL(mmContext, {
                                model: mmModel,
                                dbDriver: baseModelSqlv2.dbDriver
                            });
                            const assocAlias = `__nc${getAliasCount()}`;
                            selectQb.join(knex.raw(`?? as ??`, [
                                mmBaseModel.getTnPath(mmModel.table_name),
                                assocAlias
                            ]), `${assocAlias}.${mmChildColumn.column_name}`, `${prevAlias}.${childColumn.column_name}`).join(knex.raw(`?? as ??`, [
                                parentBaseModel.getTnPath(parentModel.table_name),
                                nestedAlias
                            ]), `${nestedAlias}.${parentColumn.column_name}`, `${assocAlias}.${mmParentColumn.column_name}`);
                            await (0, _conditionV2.extractLinkRelFiltersAndApply)({
                                context,
                                column: lookupColumn,
                                table: parentModel,
                                baseModel: parentBaseModel,
                                qb: selectQb,
                                alias
                            });
                        }
                }
                /*selectQb.join(
`${parentModel.title} as ${nestedAlias}`,
`${nestedAlias}.${parentColumn.title}`,
`${prevAlias}.${childColumn.title}`
);*/ lookupColumn = await nestedLookup.getLookupColumn(refContext);
                prevAlias = nestedAlias;
            }
            switch(lookupColumn.uidt){
                case _nocodbsdk.UITypes.Links:
                case _nocodbsdk.UITypes.Rollup:
                    {
                        const builder = (await (0, _genRollupSelectv2.default)({
                            baseModelSqlv2,
                            knex,
                            alias: prevAlias,
                            columnOptions: await lookupColumn.getColOptions(context),
                            parentColumns
                        })).builder;
                        // selectQb.select(builder);
                        if (isArray) {
                            const qb = selectQb;
                            selectQb = (fn)=>knex.raw((0, _formulaquerybuilderhelpers.getAggregateFn)(fn)({
                                    qb,
                                    knex,
                                    cn: knex.raw(builder).wrap('(', ')')
                                })).wrap('(', ')');
                        } else {
                            selectQb.select(knex.raw(builder).wrap('(', ')'));
                        }
                    }
                    break;
                case _nocodbsdk.UITypes.LinkToAnotherRecord:
                    {
                        const nestedAlias = `__nc_formula${getAliasCount()}`;
                        const isMMLike = (0, _nocodbsdk.isMMOrMMLike)(lookupColumn);
                        const relation = await lookupColumn.getColOptions(context);
                        const { parentContext, childContext, mmContext } = await relation.getParentChildContext(context);
                        const colOptions = await lookupColumn.getColOptions(context);
                        const childColumn = await colOptions.getChildColumn(childContext);
                        const parentColumn = await colOptions.getParentColumn(parentContext);
                        const childModel = await childColumn.getModel(childContext);
                        await childModel.getColumns(childContext);
                        const parentModel = await parentColumn.getModel(parentContext);
                        await parentModel.getColumns(parentContext);
                        const parentBaseModel = await _models.Model.getBaseModelSQL(parentContext, {
                            model: parentModel,
                            dbDriver: baseModelSqlv2.dbDriver
                        });
                        const childBaseModel = await _models.Model.getBaseModelSQL(childContext, {
                            model: childModel,
                            dbDriver: baseModelSqlv2.dbDriver
                        });
                        let cn;
                        let relationType = isMMLike ? _nocodbsdk.RelationTypes.MANY_TO_MANY : relation.type;
                        if (relationType === _nocodbsdk.RelationTypes.ONE_TO_ONE) {
                            var _relationCol_meta2;
                            relationType = ((_relationCol_meta2 = relationCol.meta) == null ? void 0 : _relationCol_meta2.bt) ? _nocodbsdk.RelationTypes.BELONGS_TO : _nocodbsdk.RelationTypes.HAS_MANY;
                        }
                        switch(relationType){
                            case _nocodbsdk.RelationTypes.BELONGS_TO:
                                {
                                    var _parentModel_displayValue;
                                    selectQb.join(knex.raw(`?? as ??`, [
                                        parentBaseModel.getTnPath(parentModel.table_name),
                                        nestedAlias
                                    ]), `${alias}.${childColumn.column_name}`, `${nestedAlias}.${parentColumn.column_name}`);
                                    cn = knex.raw('??.??', [
                                        nestedAlias,
                                        parentModel == null ? void 0 : (_parentModel_displayValue = parentModel.displayValue) == null ? void 0 : _parentModel_displayValue.column_name
                                    ]);
                                }
                                break;
                            case _nocodbsdk.RelationTypes.HAS_MANY:
                                {
                                    var _childModel_displayValue;
                                    isArray = relation.type !== _nocodbsdk.RelationTypes.ONE_TO_ONE;
                                    selectQb.join(knex.raw(`?? as ??`, [
                                        childBaseModel.getTnPath(childModel.table_name),
                                        nestedAlias
                                    ]), `${alias}.${parentColumn.column_name}`, `${nestedAlias}.${childColumn.column_name}`);
                                    cn = knex.raw('??.??', [
                                        nestedAlias,
                                        childModel == null ? void 0 : (_childModel_displayValue = childModel.displayValue) == null ? void 0 : _childModel_displayValue.column_name
                                    ]);
                                }
                                break;
                            case _nocodbsdk.RelationTypes.MANY_TO_MANY:
                                var _parentModel_displayValue1;
                                {
                                    isArray = true;
                                    const mmModel = await relation.getMMModel(mmContext);
                                    const mmParentColumn = await relation.getMMParentColumn(mmContext);
                                    const mmChildColumn = await relation.getMMChildColumn(mmContext);
                                    const mmBaseModel = await _models.Model.getBaseModelSQL(mmContext, {
                                        model: mmModel,
                                        dbDriver: baseModelSqlv2.dbDriver
                                    });
                                    const assocAlias = `__nc${getAliasCount()}`;
                                    selectQb.join(knex.raw(`?? as ??`, [
                                        mmBaseModel.getTnPath(mmModel.table_name),
                                        assocAlias
                                    ]), `${assocAlias}.${mmChildColumn.column_name}`, `${alias}.${childColumn.column_name}`).join(knex.raw(`?? as ??`, [
                                        parentBaseModel.getTnPath(parentModel.table_name),
                                        nestedAlias
                                    ]), `${nestedAlias}.${parentColumn.column_name}`, `${assocAlias}.${mmParentColumn.column_name}`);
                                }
                                cn = knex.raw('??.??', [
                                    nestedAlias,
                                    parentModel == null ? void 0 : (_parentModel_displayValue1 = parentModel.displayValue) == null ? void 0 : _parentModel_displayValue1.column_name
                                ]);
                        }
                        if (isArray) {
                            const qb = selectQb;
                            selectQb = (fn)=>knex.raw((0, _formulaquerybuilderhelpers.getAggregateFn)(fn)({
                                    qb,
                                    knex,
                                    cn: cn != null ? cn : lookupColumn.column_name
                                })).wrap('(', ')');
                        } else {
                            selectQb.select(`${prevAlias}.${cn}`);
                        }
                    }
                    break;
                case _nocodbsdk.UITypes.Formula:
                    {
                        const formulaOption = await lookupColumn.getColOptions(context);
                        const lookupModel = await lookupColumn.getModel(context);
                        const columns = await lookupModel.getColumns(context);
                        parentColumns = (parentColumns != null ? parentColumns : _nocodbsdk.CircularRefContext.make()).cloneAndAdd({
                            id: lookupColumn.id,
                            title: lookupColumn.title,
                            table: lookupModel == null ? void 0 : lookupModel.title
                        });
                        const { builder } = await _formulaQueryBuilder(_extends({}, params, {
                            _tree: formulaOption.formula,
                            model: lookupModel,
                            parsedTree: formulaOption.getParsedTree(),
                            parentColumns,
                            tableAlias: prevAlias,
                            column: lookupColumn,
                            columns
                        }));
                        if (isArray) {
                            const qb = selectQb;
                            selectQb = (fn)=>knex.raw((0, _formulaquerybuilderhelpers.getAggregateFn)(fn)({
                                    qb,
                                    knex,
                                    cn: knex.raw(builder).wrap('(', ')')
                                })).wrap('(', ')');
                        } else {
                            selectQb.select(builder);
                        }
                    }
                    break;
                case _nocodbsdk.UITypes.Barcode:
                case _nocodbsdk.UITypes.QrCode:
                    {
                        const referenceColumn = await (await lookupColumn.getColOptions(refContext)).getValueColumn(refContext);
                        if (isArray) {
                            const qb = selectQb;
                            selectQb = (fn)=>knex.raw((0, _formulaquerybuilderhelpers.getAggregateFn)(fn)({
                                    qb,
                                    knex,
                                    cn: `${prevAlias}.${referenceColumn.column_name}`
                                })).wrap('(', ')');
                        } else {
                            selectQb.select(`${prevAlias}.${referenceColumn.column_name}`);
                        }
                        break;
                    }
                case _nocodbsdk.UITypes.CreatedBy:
                case _nocodbsdk.UITypes.LastModifiedBy:
                case _nocodbsdk.UITypes.CreatedTime:
                case _nocodbsdk.UITypes.LastModifiedTime:
                    {
                        const refCol = await (0, _helpers.getRefColumnIfAlias)(context, lookupColumn);
                        if (isArray) {
                            const qb = selectQb;
                            selectQb = (fn)=>knex.raw((0, _formulaquerybuilderhelpers.getAggregateFn)(fn)({
                                    qb,
                                    knex,
                                    cn: `${prevAlias}.${refCol.column_name}`
                                })).wrap('(', ')');
                        } else {
                            selectQb.select(`${prevAlias}.${refCol.column_name}`);
                        }
                        break;
                    }
                case _nocodbsdk.UITypes.Attachment:
                    {
                        {
                            if (isArray) {
                                const qb = selectQb;
                                const cn = `${prevAlias}.${lookupColumn.column_name}`;
                                selectQb = (fn)=>{
                                    console.log('fn', fn, knex.clientType());
                                    if (knex.clientType() === _nocodbsdk.ClientType.PG && (!fn || (fn.toLowerCase == null ? void 0 : fn.toLowerCase.call(fn)) === 'concat')) {
                                        return knex.raw([
                                            `select jsonb_agg(__elem)::text`,
                                            `from (`,
                                            `  ??`,
                                            `) t`,
                                            `cross join lateral jsonb_array_elements(__val::jsonb) as __elem`
                                        ].join(' '), [
                                            qb.clear('select').select(knex.raw('?? as __val', [
                                                cn
                                            ]))
                                        ]).wrap('(', ')');
                                    } else {
                                        return knex.raw((0, _formulaquerybuilderhelpers.getAggregateFn)(fn)({
                                            qb,
                                            knex,
                                            cn: `${prevAlias}.${lookupColumn.column_name}`
                                        })).wrap('(', ')');
                                    }
                                };
                            } else {
                                selectQb.select(`${prevAlias}.${lookupColumn.column_name}`);
                            }
                        }
                        break;
                    }
                default:
                    {
                        if (isArray) {
                            const qb = selectQb;
                            selectQb = (fn)=>knex.raw((0, _formulaquerybuilderhelpers.getAggregateFn)(fn)({
                                    qb,
                                    knex,
                                    cn: `${prevAlias}.${lookupColumn.column_name}`
                                })).wrap('(', ')');
                        } else {
                            selectQb.select(`${prevAlias}.${lookupColumn.column_name}`);
                        }
                    }
                    break;
            }
            if (selectQb) {
                return {
                    builder: typeof selectQb === 'function' ? selectQb : knex.raw(selectQb).wrap('(', ')')
                };
            }
        }
    };
